export const WEBINAR_LOCALIZED_TEXT = {
  actions: {
    registerNow: 'dashboard.learningHub.webinar.actions.registerNow',
    viewSchedule: 'dashboard.learningHub.webinar.actions.viewSchedule',
    watchNow: 'dashboard.learningHub.webinar.actions.watchNow'
  },
  sections: {
    blueprintForSuccess: 'dashboard.learningHub.webinar.sections.blueprintForSuccess',
    moreWebinars: 'dashboard.learningHub.webinar.sections.moreWebinars',
    joinOurQA: 'dashboard.learningHub.webinar.sections.q&a',
    webinars: 'dashboard.learningHub.webinar.sections.webinars'
  }
};

export const WEBINAR_SEARCH_PARAM = 'webinar';

export const REGISTRATION_INFO = {
  titleKey: 'dashboard.learningHub.webinar.theBlueprintForSuccess.title',
  descriptionKey: 'dashboard.learningHub.webinar.theBlueprintForSuccess.description',
  imagePath: '/s2/raster/learning-webinar-intro-banner.png',
  mobileImagePath: '/s2/raster/learning-webinar-intro-banner-xs.png',
  externalUrl: 'https://events.zoom.us/ev/Aq4mDvFGeFLuufJWkFkVuAYRnnhzUsXoqXT7Ejeom8gnceKBuyXO~ArIFoTn9ZqvjCfDUfKIg4omFhbtpnd-TxbsN8SO9GcKoJSqiopFbuYKSwQ'
};
